import { render, staticRenderFns } from "./TVButton.vue?vue&type=template&id=28af1024&"
import script from "./TVButton.vue?vue&type=script&lang=ts&"
export * from "./TVButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports